var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "p-4" },
        [
          _c(
            "div",
            { staticClass: "toolbar-card" },
            [
              _c("absent-letter-filter-bar", {
                attrs: {
                  date: _vm.date,
                  "id-class": _vm.idClass,
                  "id-grade": _vm.idGrade,
                  "absent-letter-status": _vm.absentLetterStatus,
                  keyword: _vm.keyword,
                },
                on: { change: _vm.handleFilterChange },
              }),
              _c("div", { staticClass: "student-toolbar-divider" }),
              _c("absent-letter-task", {
                on: {
                  constitutive: _vm.handleOpenConfigDialog,
                  "reason-config": _vm.handleOpenReasonConfigDialog,
                  "approve-multi": _vm.fetchApprovedMulti,
                  "delete-multi": _vm.fetchDeleteMulti,
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "attendance-data-card" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "card-body-table" },
              [
                _c("absent-letter-table", {
                  attrs: { loading: _vm.isLoading, items: _vm.items },
                  on: {
                    detail: _vm.handleDetail,
                    approve: _vm.fetchApprovedLetter,
                    "selection-multi": _vm.handleMultipleSelection,
                    delete: _vm.fetchDeleteLetter,
                  },
                }),
              ],
              1
            ),
          ]),
          _c("absent-letter-footer", {
            attrs: { limit: _vm.limit, page: _vm.offset, total: _vm.total },
            on: { change: _vm.handleChangePage },
          }),
        ],
        1
      ),
      _c("absent-letter-detail", {
        ref: "absentLetterDetail",
        attrs: { "dialog-visible": _vm.dialog.detail },
        on: {
          close: _vm.handleCloseDialogDetail,
          approve: _vm.fetchApprovedLetter,
        },
      }),
      _c("absent-letter-config", {
        ref: "AbsentLetterConfig",
        attrs: { "dialog-visible": _vm.dialog.configSchool },
        on: { "dialog-close": _vm.handleCloseSystemConfigSchool },
      }),
      _c("absent-letter-reason-config", {
        ref: "AbsentLetterReasonConfig",
        attrs: { "dialog-visible": _vm.dialog.reasonConfig },
        on: { "dialog-close": _vm.handleCloseReasonConfig },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticClass: "card-title" }, [
        _vm._v("Danh sách đơn xin nghỉ học sinh"),
      ]),
      _c("p", { staticClass: "card-subtitle" }, [
        _vm._v("Theo dõi thông tin đơn xin nghỉ của học sinh"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }